var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.671,
    height: 42.615,
    viewBox: "0 0 53.671 42.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5146",
    "data-name": "Rectangle 5146",
    width: 53.671,
    height: 42.615,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13251",
    "data-name": "Group 13251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45474",
    "data-name": "Path 45474",
    d: "M69.155,99.4v1.569l-6.344,21.446c-.484,1.55-2.778,3.454-4.4,3.454H18l1.7-.443c2.089-.831,2.84-2.37,3.484-4.369,2.333-7.24,3.971-14.761,6.573-21.9a5.1,5.1,0,0,1,3.8-2.379l32.6,0A3.533,3.533,0,0,1,69.155,99.4",
    transform: "translate(-15.484 -83.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45475",
    "data-name": "Path 45475",
    d: "M0,3.7A4.711,4.711,0,0,1,3.855.169C8.322.444,13.47-.3,17.86.152a6.256,6.256,0,0,1,3.262,1.557C22.28,2.8,23.594,5.545,25.206,5.689l17.6.008c1.655-.066,4.153,2.08,4.153,3.7v1.936l-28.36,0a7.4,7.4,0,0,0-6.732,4.58C9.564,22.957,7.916,30.238,5.608,37.28a5.293,5.293,0,0,1-.837,1.885C3.429,40.832.837,40.925,0,38.745Z",
    transform: "translate(0 -0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlack);
export default __webpack_public_path__ + "static/media/folder-black.e4010ab51c803f986bdadabe18cc447d.svg";
export { ForwardRef as ReactComponent };